define('Responsive/util/noop',[],function(){
	return function(){};
});
